import axios from "services/api";;
import { API3_HOST } from '../helpers/urlHelper';

export const getAllDownDays = () => {
  return axios({
    method: 'get',
    url: `${API3_HOST}/down-days`
  });
};
